import { useContext, memo, useState, useEffect } from "react";
import { Text, Box, useMantineTheme, Loader, Stack } from "@mantine/core";
import { useModals } from "@mantine/modals";
import {
  TransactionStatus,
  useSubscribeToTransactionSubscription,
} from "src/generated/graphql";
import { FaCheckCircle } from "react-icons/fa";
import { MdOutlineError } from "react-icons/md";

type Props = {
  transactionId: string;
  onSuccess?: () => void;
  onReject?: () => void;
};

const PendingPayByCloud = ({ transactionId, onSuccess, onReject }: Props) => {
  const theme = useMantineTheme();
  const modals = useModals();

  const { data: transaction } = useSubscribeToTransactionSubscription({
    variables: {
      id: transactionId,
    },
    skip: !transactionId,
  });

  useEffect(() => {
    if (transaction?.resolveTransactionSubscription.transaction) {
      if (
        transaction.resolveTransactionSubscription.transaction
          .transactionStatus === TransactionStatus.Accepted
      ) {
        onSuccess && onSuccess();
      }
    }
  }, [transaction]);

  return (
    <Box
      mx={"md"}
      my={0}
      py={30}
      sx={{
        display: "flex",
        flexDirection: "column",
        backgroundColor: theme.colors.secondary[6],
      }}
    >
      {transaction?.resolveTransactionSubscription.transaction ? (
        transaction.resolveTransactionSubscription.transaction
          .transactionStatus === TransactionStatus.Accepted ? (
          <Stack
            style={{
              alignItems: "center",
            }}
          >
            <Text
              c={theme.colors.secondaryTextColor[6]}
              size={"xl"}
              weight={500}
            >{`Payment Successful!`}</Text>
            <FaCheckCircle size={150} color={theme.colors.primary[6]} />
          </Stack>
        ) : (
          <Stack
            style={{
              alignItems: "center",
            }}
          >
            <Text
              c={theme.colors.secondaryTextColor[6]}
              size={"xl"}
              weight={500}
            >{`Payment Failed!`}</Text>
            <MdOutlineError size={150} color={theme.colors.primary[6]} />
          </Stack>
        )
      ) : (
        <Stack
          style={{
            alignItems: "center",
          }}
        >
          <Text
            c={theme.colors.secondaryTextColor[6]}
            size={"xl"}
            weight={500}
          >{`Waiting for customer...`}</Text>
          <Loader size={150} color={theme.colors.primary[6]} />
        </Stack>
      )}
    </Box>
  );
};

export default memo(PendingPayByCloud);
